export const ROUTE = {
  HOME: '/',
  AUTH: {
    SIGNUP: '/:language/sign-up',
    SIGNUP_SUCESS: '/:language/sign-up/success',
    SIGNIN: '/:language/sign-in',
    TWO_FA: '/:language/sign-in/2fa',
    FORGOT_PASSWORD: '/:language/forgot-password',
    FORGOT_PASSWORD_SUCCESS: '/:language/forgot-password/success',
    RESET_PASSWORD: '/:language/auth/recovery',
    RESET_PASSWORD_NO_LNG: '/auth/recovery',
    RESET_PASSWORD_SUCCESS: '/:language/reset-password/success',
  },
  WITHDRAWAL: {
    CREATED: '/:language/withdrawal/created',
    SUCCESS: '/:language/withdrawal/success',
    ERROR: '/:language/withdrawal/error',
  },
  WITHDRAWAL_NO_LNG: {
    CREATED: '/withdrawal/created',
    SUCCESS: '/withdrawal/success',
    ERROR: '/withdrawal/error',
  },
  CONTACTS: '/:language/contacts',

  PRIVACY_POLICY: '/:language/privacy-policy',
  RETURN_POLICY: '/:language/return-policy',
  CLIENT_AGREEMENT: '/:language/client-agreement',

  MARKETS: {
    MARKETS: '/:language/markets',
    TRADING_SESSION: '/:language/markets/trading-sessions',
    INSTRUMENTS: '/:language/markets/instruments',
  },
  PLATFORM: '/:language/platform',
  ABOUT_COMPANY: '/:language/about-company',
};
